import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import './Pagination.css';

const Pagination = ({ page, pageSize, totalItems, onPageChange, onPageSizeChange, showPageSize = true }) => {
  const totalPages = Math.ceil(totalItems / pageSize);

  return (
    <div className="pagination">
      <div className="pagination-info">
        {showPageSize && (
          <select
            value={pageSize}
            onChange={(e) => {
              onPageSizeChange(Number(e.target.value));
              onPageChange(1);
            }}
            className="page-size-select"
          >
            <option value="5">5 items</option>
            <option value="10">10 items</option>
            <option value="25">25 items</option>
            <option value="50">50 items</option>
            <option value="100">100 items</option>
          </select>
        )}
        <span>
          Page {page} of {totalPages}
        </span>
      </div>

      <div className="pagination-buttons">
        <button
          disabled={page === 1}
          onClick={() => onPageChange(page - 1)}
          className="pagination-btn"
        >
          <FiChevronLeft size={18} /> Previous
        </button>

        {Array.from({ length: totalPages }, (_, i) => i + 1)
          .filter(p => Math.abs(p - page) <= 2)
          .map(p => (
            <button
              key={p}
              onClick={() => onPageChange(p)}
              className={`pagination-btn ${p === page ? 'active' : ''}`}
            >
              {p}
            </button>
          ))}

        <button
          disabled={page === totalPages}
          onClick={() => onPageChange(page + 1)}
          className="pagination-btn"
        >
          Next <FiChevronRight size={18} />
        </button>
      </div>
    </div>
  );
};

export default Pagination;